import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CruisePage from "./pages/CruisePage";
import HousesPage from "./pages/HousesPage";
import BikesPage from "./pages/BikesPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ScrollToTop from "./hooks/useScrollToTop";
import { LINKS } from "./config/links";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path={LINKS.routes.home} element={<HomePage />} />

        <Route path={LINKS.routes.cruises.pl} element={<CruisePage />} />
        <Route path={LINKS.routes.cruises.en} element={<CruisePage />} />

        <Route path={LINKS.routes.houses.pl} element={<HousesPage />} />
        <Route path={LINKS.routes.houses.en} element={<HousesPage />} />

        <Route path={LINKS.routes.bikes.pl} element={<BikesPage />} />
        <Route path={LINKS.routes.bikes.en} element={<BikesPage />} />

        <Route path={LINKS.routes.privacy.pl} element={<PrivacyPolicy lang="pl" />} />
        <Route path={LINKS.routes.privacy.en} element={<PrivacyPolicy lang="en" />} />
      </Routes>
    </>
  );
}

export default App;